import * as React from "react";
import { styled } from "@mui/material/styles";
import Header from "./layout/header";
import { Outlet, useLocation } from "react-router-dom";
import Footer from "./layout/footer/index";
import { useDispatch } from "react-redux";
import { changeSkin } from "./store/skinSlice";
import { useEffect } from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import WhatsappBtn from "./components/whatsappBtn";
import { detectVisitorCountry } from "./utils/detectCountry";

import Intercom from "@intercom/messenger-js-sdk";

const ProductHeroLayoutRoot = styled("section")(({ theme }) => ({
  color: theme.palette.common.black,
  height: "100vh",
  width: "100%",
  minHeight: 500,
  position: "relative",
}));

const layoutTheme = createTheme({
  breakpoints: {
    values: {
      xs: 250,
      xm: 520,
      sm: 760,
      md: 960,
      mg: 961,
      lg: 1280,
      lgUp: 1281,
      gx: 1360,
      xl: 1440,
    },
  },
});

function App() {
  useEffect(() => {
    detectVisitorCountry();
  }, []);

  useEffect(() => {
    let visitorId = localStorage.getItem("toposfysiteid");
    if (!visitorId) {
      visitorId = "toposfysiteid" + Date.now();
      localStorage.setItem("toposfysiteid", visitorId);
    }
    Intercom({
      app_id: "u9w4iaxm",
      user_id: visitorId + "_toposfy官网",
      name: "游客",
      created_at: Math.floor(Date.now() / 1000),
    });
  }, []);

  const dispatch = useDispatch();
  let loc = useLocation();
  useEffect(() => {
    let data = { light: true, barBg: "#eee", menuBg: "#fff", color: "#000" };
    if (loc.pathname.includes("/scene") || loc.pathname.includes("/partners")) {
      data = {
        light: false,
        barBg: "rgba(244, 244, 245, 1)",
        menuBg: "rgb(227 227 227)",
        color: "#000",
      };
    }
    dispatch(changeSkin(data));
  }, [loc.pathname, dispatch]);

  return (
    <ThemeProvider theme={layoutTheme}>
      <ProductHeroLayoutRoot>
        <Header />
        <Outlet />
        <Footer />
        <WhatsappBtn />
      </ProductHeroLayoutRoot>
    </ThemeProvider>
  );
}

export default App;
